import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdOutlinePolicy, MdPolicy, } from "react-icons/md";
import { BsBadgeAd, BsBadgeAdFill } from "react-icons/bs";
import { IoMenu, IoClose } from 'react-icons/io5';
import { FaRegCirclePlay } from "react-icons/fa6";
import { FaPhotoVideo, FaPlayCircle } from 'react-icons/fa';
import { BiCricketBall, BiSolidCricketBall } from "react-icons/bi";
import { SiGoogleanalytics } from 'react-icons/si';

const Navbar1 = () => {
    const [isOpen, setIsOpen] = useState(false);  // Start with closed navbar
    const [isMobile, setIsMobile] = useState(false); // Track if we're on mobile
    const location = useLocation();
    const [onSelect, setOnSelect] = useState([]);  // Initialize as an empty array

    // Check for mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Initial check
        checkMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Open navbar on hover (desktop only)
    const handleMouseEnter = () => {
        if (!isMobile) {
            setIsOpen(true);
        }
    };

    // Close navbar after delay on mouse leave (desktop only)
    const handleMouseLeave = () => {
        if (!isMobile) {
            setTimeout(() => setIsOpen(false), 100);  // Delay before closing
        }
    };

    // Toggle menu on mobile
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Helper function to determine the selected link class
    const getSelectedClass = (item) => {
        return onSelect.includes(item) ? 'border-r-2 border-main-blue text-main-blue' : 'text-main-subfont';
    };

    useEffect(() => {
        const pathArray = location.pathname.split('/');  // Split the pathname into segments
        // If the path is empty (i.e., the user is on the homepage), default to 'dashboard'
        setOnSelect(pathArray[1] === '' ? ['dashboard'] : pathArray);
    }, [location.pathname]);  // Re-run when pathname changes

    const getSelectedIcon = (item) => {
        return onSelect.includes(item) ? true : false
    };

    // Close mobile menu when a link is clicked
    const handleLinkClick = () => {
        if (isMobile) {
            setIsOpen(false);
        }
    };

    return (
        <>
            {/* Mobile menu toggle button */}
            {isMobile && (
                <button
                    className="fixed top-4 left-4 z-50 bg-main-blue text-white p-2 rounded-md shadow-md"
                    onClick={toggleMenu}
                    aria-label="Toggle navigation menu"
                >
                    {isOpen ? <IoClose size={24} /> : <IoMenu size={24} />}
                </button>
            )}

            <div
                className={`fixed top-0 z-50 left-0 h-screen transition-all duration-300 ease-in-out ${isMobile ? (isOpen ? 'w-64 translate-x-0' : 'w-0 -translate-x-full') :
                    isOpen ? 'w-50' : 'w-15'
                    } ${isMobile ? 'mt-16' : 'mt-[5%]'}`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <nav className="bg-main-white text-main-subfont h-screen flex flex-col overflow-hidden">
                    <ul className="space-y-2 py-4 flex-1">
                        <li className={`${getSelectedClass('policy')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/policy"
                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('policy') ? <MdPolicy size={22} /> : <MdOutlinePolicy size={22} />}
                                {(isOpen || isMobile) && <span className="ml-3 text-sm md:text-base">Policy</span>}
                            </Link>
                        </li>
                        <li className={`${getSelectedClass('video')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/add/video"
                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('video') ? <FaPhotoVideo size={22} /> : <FaPhotoVideo size={22} />}
                                {(isOpen || isMobile) && <span className="ml-3 text-sm md:text-base">Video</span>}
                            </Link>
                        </li>

                        <li className={`${getSelectedClass('story')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/add/story"
                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('story') ? <FaPlayCircle size={20} /> : <FaRegCirclePlay size={20} />}

                                {(isOpen || isMobile) && <span className="ml-3">Story</span>}
                            </Link>
                        </li>
                        <li className={`${getSelectedClass('liveMatch')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/add/liveMatch"
                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('liveMatch') ? <BiSolidCricketBall size={22} /> : <BiCricketBall size={22} />}

                                {(isOpen || isMobile) && <span className="ml-3 text-sm md:text-base">Live Match</span>}
                            </Link>
                        </li>

                        <li className={`${getSelectedClass('ads')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/manage/ads/nativeAds/add"

                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('ads') ? <BsBadgeAdFill size={20} /> : <BsBadgeAd size={20} />}

                                {(isOpen || isMobile) && <span className="ml-3 text-sm md:text-base">Ads Manager</span>}
                            </Link>
                        </li>
                        <li className={`${getSelectedClass('adstrack')} hover:bg-main-bg px-2`}>
                            <Link
                                to="/manage/adstrack"

                                className={`py-3 px-4 rounded hover:text-main-blue hover:bg-main-bg flex items-center ${!isOpen && !isMobile && 'justify-center'}`}
                                onClick={handleLinkClick}
                            >
                                {getSelectedIcon('adstrack') ? <SiGoogleanalytics size={20} /> : <SiGoogleanalytics size={20} />}

                                {(isOpen || isMobile) && <span className="ml-3 text-sm md:text-base">Ads Analytics</span>}
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* Overlay for mobile when menu is open */}
            {
                isMobile && isOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 -z-10"
                        onClick={toggleMenu}
                    ></div>
                )
            }
        </>
    );
};

export default Navbar1;